import { render, staticRenderFns } from "./VModal.vue?vue&type=template&id=76a8b3f2&scoped=true&"
import script from "./VModal.vue?vue&type=script&lang=ts&"
export * from "./VModal.vue?vue&type=script&lang=ts&"
import style0 from "./VModal.vue?vue&type=style&index=0&id=76a8b3f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a8b3f2",
  null
  
)

export default component.exports